'use strict';

var $ = require('jquery');
var basePage = require('../pages/base-page.js');

function alignBlockGrid() {
	$(document).foundation({
		equalizer : {
			equalize_on_stack: false
		}
	});
}

basePage.init = function() {
	basePage.initBasePage();
	alignBlockGrid();
};

module.exports = basePage;